import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'view-grade-intersect-btn',
  templateUrl: './view-grade-intersect-btn.component.html',
  styleUrls: ['./view-grade-intersect-btn.component.scss']
})
export class ViewGradeIntersectBtnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
